(() => {
  const definitions = {
    'CoQ10': 'Coenzyme Q10 is a compound naturally present in cells and involved in their energy production.',
    'D-Ribose': 'D-Ribose is a sugar molecule used by the body as a building block of ATP.',
    'Cinnulin PF®': 'Cinnulin PF® is a water-soluble cinnamon bark extract used in REVd®.',
    'Alpha-GPC': 'Alpha-GPC is a source of choline, an essential nutrient.',
    'plant sterols': 'Plant sterols are naturally occurring compounds found in plants.',
    'electrolytes': 'Electrolytes are minerals with an electric charge, including sodium and potassium.',
    'green tea': 'Green tea comes from the leaves of the Camellia sinensis plant.',
    'guarana extract': 'Guarana is a plant extract that naturally contains caffeine.'
  };
  const expression = /Cinnulin PF®|guarana extract|plant sterols|electrolytes|Alpha-GPC|D-Ribose|green tea|CoQ10/gi;
  function enhance(root) {
    const scope = root.querySelector('main') || root.querySelector('[role="main"]') || root;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.parentElement || !node.textContent.trim() || !expression.test(node.textContent)) { expression.lastIndex = 0; return NodeFilter.FILTER_REJECT; }
        expression.lastIndex = 0;
        if (node.parentElement.closest('a,button,script,style,textarea,select,option,svg,.ho-science__term,.ho-ingredient-term,[contenteditable],[data-ho-no-ingredients],.shopify-payment-button')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const fragment = document.createDocumentFragment(); let start = 0;
      for (const match of node.textContent.matchAll(expression)) {
        fragment.append(document.createTextNode(node.textContent.slice(start, match.index)));
        const term = match[0]; const definition = definitions[Object.keys(definitions).find(key => key.toLowerCase() === term.toLowerCase())];
        const button = document.createElement('button'); button.type = 'button'; button.className = 'ho-ingredient-term'; button.textContent = term; button.dataset.definition = definition; button.setAttribute('aria-label', `${term}: ${definition}`); button.title = definition;
        fragment.append(button); start = match.index + term.length;
      }
      fragment.append(document.createTextNode(node.textContent.slice(start))); node.replaceWith(fragment);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document)); else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('click', event => { if (!event.target.closest('.ho-ingredient-term')) document.activeElement?.classList?.contains('ho-ingredient-term') && document.activeElement.blur(); });
})();
